import { render, staticRenderFns } from "./ReportSummaryCards.vue?vue&type=template&id=13b5ed15"
import script from "./ReportSummaryCards.vue?vue&type=script&lang=js"
export * from "./ReportSummaryCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports